import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './BusinessInformationComponent.metadata.json5';
import styles from '../Miscellanous.module.scss'
import CompanyContractDetailsComponent from '../subcomponents/CompanyContractDetails/CompanyContractDetailsComponent';

function BusinessInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    
    modelVM.value.isValidationReq = true

    const getTotalNumberOfEmployees = () => {
        const noOfCanEmp = _.isUndefined(modelVM.value.numOfCanEmp11) ? 0 : modelVM.value.numOfCanEmp11;
        const noOfUSAEmp = _.isUndefined(modelVM.value.numOfUSAEmp12) ? 0 : modelVM.value.numOfUSAEmp12;

        return noOfCanEmp + noOfUSAEmp;
    }

    const calculateAverageContactValue = () => {      
        let sum = 0.00;
  
        if (!_.isUndefined(modelVM.value.companyContactDetails) && !_.isEmpty(modelVM.value.companyContactDetails[0])) {
            _.each(modelVM.value.companyContactDetails, (contact) => {
                sum += _.isUndefined(contact.proVal3) ? 0.00 : parseFloat(contact.proVal3.amount)
            });
       
            return  sum/modelVM.value.companyContactDetails.length;     
        }

        return 0        
    } 

    const calculateLargeContactValue = () => {   
        let maxVal = 0.00;
    
        if (!_.isUndefined(modelVM.value.companyContactDetails) && !_.isEmpty(modelVM.value.companyContactDetails[0])) {
            maxVal = _.max(modelVM.value.companyContactDetails.map((contact) => _.isUndefined(contact.proVal3) ? 0.00 : contact.proVal3.amount))    
        }

        return maxVal;
    } 

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPleDes4: {
            visible: !_.isUndefined(modelVM.value.comStr3) && modelVM.value.comStr3 === 'Oth'
        },
        companyContractDetailsComponent: {
            data: modelVM.companyContactDetails,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.companyContactDetails`
        },
        totNumOfEmp13: {
            value: getTotalNumberOfEmployees()
        },
        averageContractValue: {
           value: {
                    amount: calculateAverageContactValue()
                }
        },
        largestContractValue: {
            value: {
                    amount: calculateLargeContactValue()
                }
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            companyContractDetailsComponent: CompanyContractDetailsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={handleValueChange}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessInformationComponent.propTypes = wizardProps;
export default withRouter(BusinessInformationComponent);
